import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';

const Flash = ({ flashType, message, close }) => (
    <aside className={`ckp-admin-flash is-${flashType} ${message ? 'is-open' : ''}`}>
        {flashType === 'error' ? (
            <ErrorIcon className="ckp-admin-flash-icon" />
        ) : (
            <InfoIcon className="ckp-admin-flash-icon" />
        )}
        <span className="ckp-admin-flash-message">{message}</span>
        <IconButton className="ckp-admin-flash-close" onClick={close} color="inherit">
            <CloseIcon />
        </IconButton>
    </aside>
);

Flash.defaultProps = { type: 'success' };

export default Flash;
